import { IUserData, IUser, IUserDetailData, IUserDetail } from "./user.types";
import { User, UserDetail } from "./user";
import { mockCountriesData, mockRolesData, mockUserClientData } from "@/entities";

export const mockUsersData = (): IUserData[] => [
  {
    id: 1,
    username: "ES00000000",
    name: "Admin",
    lastName: "Admin",
    email: "cash.innovacion-webclientes@prosegur.com",
    createdAt: "2021-05-04T08:04:27.922+00:00",
    updatedAt: "2021-05-05T08:00:55.725+00:00",
    active: true,
    admin: true,
    supervisor: true,
    country: mockCountriesData()[0],
    roles: mockRolesData(),
  },
  {
    id: 3,
    username: "ESX0000000",
    name: "Prueba",
    lastName: "PruebaQA",
    email: "ext.user@ext.prosegur.com",
    createdAt: "2021-05-04T08:16:43.572+00:00",
    updatedAt: "2021-05-04T13:40:29.716+00:00",
    active: true,
    admin: true,
    supervisor: false,
    country: mockCountriesData()[1],
    roles: mockRolesData(),
  },
];

export const mockUsers = (data: IUserData[] = mockUsersData()): IUser[] =>
  data.map((item) => new User(item));

export const mockUserDetailData = (): IUserDetailData => ({
  ...mockUsersData()[0],
  clients: mockUserClientData(),
});

export const mockUserDetail = (): IUserDetail => new UserDetail(mockUserDetailData());
